import { Route } from 'vue-router';
import Vue from 'vue';
import _ from '../utils';
import { Guard } from '../plugins/guards/guardWrapper';

export default {
  name: 'UnverifiedUserGuard',
  async routeBeforeEnter(to: Route, from: Route) {
    try {
      await Vue.$config.promise;
      const isUnverified = Vue.$auth.isInRole('unverified');
      const routeNeedsAuth = await Vue.$routerUtils.getRouteOption<boolean>(Vue.$router.currentRoute, 'auth');
      if (isUnverified && routeNeedsAuth) {
        // unverified users must verify first. they should not get access to the software
        const verifyRoute = Vue.$config.values['auth-redirects-verify-user'];
        if (!Vue.$routerUtils.areRoutesSame(verifyRoute, to)) {
          return verifyRoute;
        }
      }
    } catch (error) {
      Vue.$log.error(error);
    }
    return undefined;
  },
} as Guard;
